<template>
  <div>
    <!-- <el-top-nav-menu-3
      :logo="logoBase"
      appTitle="分包商注册"
      :dashboard="baseUrl"
      :Menu4Href="true"
      width="1180px"
      :subMenu="[]"
      ref="topNavMenu"
    >
    </el-top-nav-menu-3> -->
    <!-- 分包商注册 -->
    <el-top-nav-menu-4
      :companyTitle="$t('subcontractor.menuTitle')"
      :showInput="false"
      :Menu4Href="true"
      ref="topNavMenu"
      :logo="LOGOs"
      width="1180px"
      padding="0"
      :showHelp="true"
    >
      <!-- <div class="ldg" @click="goser">
        <span class="dpng">{{ $t("page.applyUsername.btn.msg10") }}</span>
        <div class="los">
          <img :src="leftgg" />
        </div>
      </div> -->
    </el-top-nav-menu-4>
    <div class="registerBox">
      <!-- 分包商注册 -->
      <div class="title">{{ $t('subcontractor.menuTitle') }}</div>
      <!-- <el-steps
        class="steps"
        :space="180"
        :align-center="true"
        :active="active"
        finish-status="success"
      >
        <el-step
          :class="active === 0 ? 'currentStep' : ''"
          title="填写注册信息"
        ></el-step>
        <el-step
          :class="active === 1 ? 'currentStep' : ''"
          title="通用信息标准"
        ></el-step>
        <el-step
          :class="active === 2 ? 'currentStep' : ''"
          title="专用信息标准"
        ></el-step>
      </el-steps> -->
      <div class="main">
        <firstStep
          v-if="active == 0"
          :extForm="registerForm.subconAuthAccountInfo"
          :subconBaseInfo="registerForm.subconBaseInfo"
          :registerForm="registerForm"
          @open="openDialog"
          @getStep="getStep"
        >
        </firstStep>
        <!-- <secondStep
          :extForm="registerForm"
          :secondFiles="secondFiles"
          :industryCategoryList="industryCategoryList"
          v-if="active == 1"
          @open="openDialog"
          @getStep="getStep"
        ></secondStep>
        <thirdStep
          v-if="active == 2"
          :thirdStepId="registerForm.subconBaseInfo.id"
          :industryCategoryList="industryCategoryList"
          :extForm="registerForm"
          :thirdFiles="thirdFiles"
          @open="openDialog"
          @getStep="getStep"
        ></thirdStep> -->
      </div>
    </div>
  </div>
</template>

<script>

import logoBase from "../../../assets/images/zjLogo.png";
import {
  queryProfessionList
} from "@/api/subcontractor-register";
import firstStep from "./steps/firstStep.vue";
// import secondStep from "./steps/secondStep.vue";
// import thirdStep from "./steps/thirdStep.vue";
import LOGO from "@/assets/images/logoS.png";
// ../../..
// @/assets/images/logoS.png
export default {
  components: {
    firstStep,
    logoBase,
    LOGO,
  },
  data() {
    return {
      LOGOs: require("@/assets/images/jrzl.png"),
      centerDialogVisible: false,
      firstItem: {},
      logoBase,
      baseUrl: this.$addUrlPerFix(process.env.VUE_APP_SHOPPAGE_URL),
      showInput: false,
      active: 0, //步骤条进度
      secondStepId: "",
      secondFiles: {
        idFront: null,  // 身份证正面
        idBack: null,  // 身份证反面
        legalRepresentative: null,  // 法人授权委托书
        businessLicense: null,  // 营业执照
        SafetyPermits: null  // 安全许可证
      },
      thirdFiles: {
        zscl: null // 政审材料
      },
      registerForm: {
        // 基础信息
        subconBaseInfo: {
          inputValue: "",
          // 是否内部单位
          yesNoCopy: "",
          isJoinMerge: 0
        },
        subconCooUnitInfo: {},
        // legalPersonInfo: {
        //   legalPersonName: "",  // 法人姓名
        //   legalPersonPhone: "",  // 法人电话号码
        //   cardType: "", // 法人证件类型
        //   legalPersonIdCard: "", // 法人证件号码
        //   legalPersonCardValidityStart: "", // 法人证件号码有效期起期
        //   legalPersonCardValidityEnd: "", // 法人证件号码有效期止期
        //   legalPersonCardFront: "",  // 身份证扫描件证明
        //   legalPersonCardBack: ""  // 身份证扫描件反面
        // },
        // 分包商专业
        subconSubjectChange: [],
        // 授权账号信息
        subconAuthAccountInfo: {
          // 姓名
          authUserName: "",
          // 手机号
          phone: "",
          // 密码
          password: "",
          // 二次确认密码
          secondaryPassword: "",
          // 供应商名称
          supplierName: "",
          // 信用代码
          unifiedCreditCode: "",
          // 合作单位
          cooUnitName: "",
          authCertificate: "",
          // 合作单位编码
          cooUnitCode: "",
          // 合作单位id
          cooUnitId: "",
          // 验证码
          verificationCode: "",
          cardType: "",
          registerEmail: "",
          authPersonIdCard: "",
          isAuthCertificate: "1"
        },
        // 分包商行业类别
        subconCooProfessionBOS: [],
        subconCooProfessionList: [],
        // 财务能力
        subconTyPfe: [],
        // 技术人员信息
        subconManagePersonAndFilesBO: {
          subconFileinfoBOS: [],  // 文件
          subconManagePersonBOs: [],  // 列表
        },
        // 获奖情况
        subconAwardBOS: [],
        // 持证管理人员
        subconcertificatedPersonAndFilesBO: {
          subconFileinfoBOS: [], // 文件
          subconManagePersonBOs: []  // 列表
        },
        // 作业班组
        subconToDoPersonAndFilesBO: {
          subconFileinfoBOS: [],   // 文件
          subconManagePersonBOs: []   // 列表
        },
        // 年生产能力
        subconProductiveCapacityBOS: [],
        // 主要设备
        subconDeviceInfoPOS: [],
        // 履约能力
        subconCooPfeBOS: [],
        subconQualificationsBOS: [],
        // 生产能力
        productionCapacity: {
          administrativeStaff: [],
          operatives: [],
          annualProductionCapacity: [],
          mainEquipment: []
        },
        // 资质列表
        subconQualificationsAndFilesBO: {
          subconFileinfoBOS: [],  // 附件
          subconQualificationsBOS: []  // 列表
        },
        // 团队成员信息
        subconManagePersonChange: [],
        //业务联系人
        subconBusinessPerson: [],
        //市场主体实控信息
        subconControlsPerson: [],
        //市场主体董监高信息
        subconExecutivePerson: [],
        // 财务信息
        // subconTyPerChange: [],
        // 其他信息
        // subconExtInfoChange: [],
        // 企业违法行为
        illegalinfoBOS: [],
        // 失信被执行人情况
        dishonestBOS: [],
        // 其他不良信息
        punishmentinfoBOS: []

      },
      // 分包商行业类别
      industryCategoryList: [],
    };
  },
  mounted(){
    this.getProfessionList()
  },
  methods: {
    openDialog() {
      this.$message({
        showClose: true,
        message: this.$t('subcontractor.submitVerifyTip.submitTip'),
        type: "warning",
      });
      // this.centerDialogVisible=true
    },
    getProfessionList() {
      queryProfessionList().then(res => {
        this.industryCategoryList = res.data.data;
      })
    },
    localData(val) {
      this.secondStepInfo = val;
    },
    next() {
      if (this.active++ > 2) this.active = 0;
    },
    // firstStep(firstItem, val) {
    //   this.firstItem = firstItem;
    //   console.log(firstItem, "firstItem");
    //   this.active = val;
    // },
    getSecondStep(id) {
      this.secondStepId = id;
    },
    getStep(val, zzq) {
      window.scrollTo(0, 0);
      this.active = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.registerBox {
  margin-top: 30px !important;
  width: 1184px !important;
  display: flex;
  flex-direction: column;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
  .title {
    font-size: 28px;
    line-height: 40px;
    margin-bottom: 40px;
    font-weight: 600;
  }
  /deep/ .steps {
    height: 100px;
    width: 55%;
  }
  width: 100%;
  margin: 0 auto;
  padding: 40px 0;
  //   margin: 0 128px !important;
  background: #ffffff;
  border-radius: 2px;
  line-height: 22px;
  /deep/ .el-steps .el-step {
    .el-step__head.is-success,
    .el-step__main el-step__title is-success {
      color: #ff152e;
      border-color: #ff152e;
    }
    .el-step__icon {
      width: 32px;
      height: 32px;
      .el-step__icon-inner {
        font-size: 20px;
      }
    }
    .el-step__title,
    .el-step__title.is-success {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ff152e;
    }
    .el-step__title {
      color: rgba(0, 0, 0, 0.45);
    }
    .el-step__title is-success,
    .el-step__title is-process {
      color: #ff152e;
    }
    .el-step__line {
      width: 70%;
      margin: 0 15%;
      background: rgba(0, 0, 0, 0.15);
    }
    .el-step__title.is-success {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff152e;
    }
  }
  // .currentStep {
  //   .el-step__head .el-step__icon {
  //     background: #ff152e;
  //     border: none;
  //     color: white;
  //     font-size: 16px;
  //   }
  // }
}
.main {
  width: 100%;
}
/deep/ .logo-container {
  width: 330px !important;
  .app-name {
    width: 240px !important;
  }
}
</style>
